import { render, staticRenderFns } from "./Outbox.vue?vue&type=template&id=efde75ca&scoped=true"
import script from "./Outbox.vue?vue&type=script&lang=js"
export * from "./Outbox.vue?vue&type=script&lang=js"
import style0 from "./Outbox.vue?vue&type=style&index=0&id=efde75ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efde75ca",
  null
  
)

export default component.exports